import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, formatGraphqlParams } from '@/utils'

export default {
    fetchAll() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    products {
                        id,
                        name,
                        price,
                        discount_price,
                        amount,
                        description,
                        category,
                        image,
                        brand,
                        bar_code,
                        is_medication,
                        active_principle,
                        need_prescription,
                        deleted_at,
                        erp_id,
                        integration_id,
                        laboratory
                    }
                }
            `
        })
    },
    update(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateProduct (
                        id: ${data.id},
                        name: "${data.name}",
                        price: ${data.price},
                        discount_price: ${data.discount_price || 0.0},
                        amount: ${data.amount},
                        description: ${JSON.stringify(data.description)},
                        category: "${data.category}",
                        image: "${data.image}",
                        brand: "${data.brand}",
                        bar_code: "${data.bar_code}",
                        laboratory: "${data.laboratory}",
                        is_medication: ${data.is_medication},
                        active_principle: "${data.active_principle}",
                        need_prescription: ${data.need_prescription},
                    ) {
                        id,
                        name,
                        price,
                        discount_price,
                        amount,
                        description,
                        category,
                        image,
                        brand,
                        bar_code,
                        is_medication,
                        active_principle,
                        need_prescription,
                        laboratory,
                        deleted_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createProduct (
                        name: "${data.name}",
                        price: ${data.price},
                        discount_price: ${data.discount_price || 0.0},
                        amount: ${data.amount},
                        description: ${JSON.stringify(data.description)},
                        category: "${data.category}",
                        image: "${data.image}",
                        brand: "${data.brand}",
                        bar_code: "${data.bar_code}",
                        is_medication: ${data.is_medication},
                        active_principle: "${data.active_principle}",
                        need_prescription: ${data.need_prescription},
                        ` + (!data.laboratory ? '' : `laboratory: "${data.laboratory}",`) + `,
                        ` + (!data.erp_id ? '' : `erp_id: ${data.erp_id},`) + `,
                    ) {
                        id,
                        name,
                        price,
                        discount_price,
                        amount,
                        description,
                        category,
                        image,
                        brand,
                        bar_code,
                        laboratory,
                        is_medication,
                        active_principle,
                        need_prescription,
                        deleted_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteProduct (
                        id: ${id}
                    )
                }
            `
        })
    },
    fetch(word = null, sortName = "name", orderBy = "ASC", erpId = null, id = null, page = 1, itemsPerPage = 4, hideNeedPrescription = false) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';

        return axios.post('', formatGraphqlBody(
            'query',
            'products',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'id',
                    erp: {
                        0: 'id',
                        1: 'erp_id',
                        2: 'corporate_name',
                        3: 'erp_name'
                    },
                    1: 'name',
                    2: 'price',
                    3: 'amount',
                    4: 'description',
                    5: 'category',
                    6: 'image',
                    7: 'brand',
                    8: 'bar_code',
                    9: 'is_medication',
                    10: 'active_principle',
                    11: 'need_prescription',
                    12: 'deleted_at',
                    13: 'integration_id',
                    14: 'erp_id',
                    15: 'laboratory',
                    16: 'discount_price'
                }
            },
          id !== null
            ? { id, pagination_page: page, pagination_limit: itemsPerPage, search_filter: word, orderBy: [sortName, orderBy], erp_id: erpId}
            : { pagination_page: page, pagination_limit: itemsPerPage, search_filter: word, orderBy: [sortName, orderBy], erp_id: erpId, hide_need_prescription_products: hideNeedPrescription}
        ))
    },
    updateProductErpInfos(data, erpId) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateProductErpInfos (
                        check_id: [${data}],
                        erp_id: ${erpId},
                    ) {
                        items {
                            id,
                            name,
                            price,
                            discount_price,
                            discount_percentage,
                            amount,
                            description,
                            category,
                            image,
                            brand,
                            bar_code,
                            laboratory,
                            is_medication,
                            active_principle,
                            need_prescription,
                            deleted_at
                            integration_id
                        }
                    }
                }
            `
        })
    },
    importProducts({
        sheet_url,
        name_sheet_column,
        price_sheet_column,
        category_sheet_column,
        bar_code_sheet_column,
        brand_sheet_column = null,
        active_principle_sheet_column = null,
        description_sheet_column = null,
        laboratory_sheet_column = null,
    }) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        const params = formatGraphqlParams({
            'sheet_url': sheet_url,
            'name_sheet_column': name_sheet_column,
            'price_sheet_column': price_sheet_column,
            'category_sheet_column': category_sheet_column,
            'bar_code_sheet_column': bar_code_sheet_column,
            'brand_sheet_column': brand_sheet_column,
            'active_principle_sheet_column': active_principle_sheet_column,
            'description_sheet_column': description_sheet_column,
            'laboratory_sheet_column': laboratory_sheet_column
        });

        return axios.post('', formatGraphqlBody(
            'mutation',
            'importProduct',
            null,
            params
        ))
    }
}